import styles from "./Card.module.css";

interface CardProps {
	children: React.ReactNode;
	className?: string;
	bodyClassName?: string;
	header?: React.ReactNode;
}

export function Card({ children, className, bodyClassName, header }: CardProps) {
	return (
		<div className={[styles.card, className].filter(Boolean).join(" ")}>
			{header && <div className={styles.header}>{header}</div>}
			<div className={[styles.body, bodyClassName].filter(Boolean).join(" ")}>{children}</div>
		</div>
	);
}
